import React from 'react';
import {Link} from "react-router-dom";
import Alert from 'react-bootstrap/Alert';

export const Error404 = () => (
  <Alert variant="warning" className="ErrorPage text-center">
    <h1>404 - Page not found</h1>
    <Link to="/" className="btn btn-primary go-home-link">Go to Home Page</Link>
  </Alert>
);
